import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import type { ClinicianClientRow } from "../../service/compliance.service";

const { Text } = Typography;

type Props = {
  clients: ClinicianClientRow[];
  total: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  loading: boolean;
};

const ComplianceClientsTable = ({ clients, total, currentPage, pageSize, onPageChange, loading }: Props) => {
  const columns: ColumnsType<ClinicianClientRow> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string) => <Text strong>{name}</Text>,
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (age: number | null) => <Text>{age || "—"}</Text>,
    },
    {
      title: "Total Notes",
      dataIndex: "total_notes",
      key: "total_notes",
      render: (total: number) => <Text>{total}</Text>,
    },
    {
      title: "Last Note",
      dataIndex: "last_note_created_at",
      key: "last_note_created_at",
      render: (date: string | null) => <Text>{date ? new Date(date).toLocaleDateString() : "—"}</Text>,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={clients}
      loading={loading}
      rowKey="uuid"
      pagination={{
        total,
        current: currentPage,
        pageSize,
        showSizeChanger: false,
        onChange: onPageChange,
      }}
      locale={{ emptyText: "No clients found for this clinician." }}
    />
  );
};

export default ComplianceClientsTable;
